import { useEffect, useRef } from "react";
import {
  Chart,
  PieController,
  ArcElement,
  Tooltip,
  Legend
} from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";

Chart.register(PieController, ArcElement, Tooltip, Legend, ChartDataLabels);

/* ---------------- HELPERS ---------------- */

function truncate(str, n) {
  if (!str) return "";
  return str.length > n ? str.slice(0, n - 3) + "..." : str;
}

function formatNumber(v) {
  return Number(v || 0).toLocaleString("tr-TR");
}

/* ---------------- COMPONENT ---------------- */

export default function PieChart({ id, rows, valueKey }) {
  const canvasRef = useRef(null);
  const chartRef = useRef(null);

  useEffect(() => {
    if (!rows?.length || !canvasRef.current) return;
    if (chartRef.current) chartRef.current.destroy();

    /* ✅ OLD HTML LOGIC */
    const baseLabels = rows.map(
      r => `${truncate(r.program, 20)} ${r.saat}`
    );

    const values = rows.map(r =>
      Math.round(Number(r[valueKey] || 0))
    );

    const labels = baseLabels.map(
      (label, i) => `${label}: ${formatNumber(values[i])}`
    );


    const canvas = canvasRef.current;

    const DISPLAY = 300;

    const REAL = 1154;

    canvas.style.width = DISPLAY + "px";
    canvas.style.height = DISPLAY + "px";
    canvas.width = REAL;
    canvas.height = REAL;


    const chart = new Chart(canvas, {
      type: "pie",
      data: {
        labels,
        datasets: [{
          data: values,
          backgroundColor: [
            "#3366cc", "#dc3912", "#ff9900", "#109618", "#990099",
            "#0099c6", "#dd4477", "#66aa00", "#b82e2e", "#316395"
          ],
          borderWidth: 1
        }]
      },
      options: {
        responsive: false,
        maintainAspectRatio: false,
        devicePixelRatio: 2,

        plugins: {
          legend: {
            display: true,
            position: "right",
            align: "center",
            labels: {
              boxWidth: 20,
              padding: 20,
              font: {
                size: 22,
                weight: "700"
              }
            }
          },

          tooltip: {
            titleFont: { size: 16 },
            bodyFont: { size: 15 },
            callbacks: {
              label: ctx => formatNumber(ctx.raw)
            }
          },

          datalabels: {
            color: "#fff",
            backgroundColor: ctx =>
              ctx.dataset.backgroundColor[ctx.dataIndex],
            borderRadius: 4,
            padding: 5,
            formatter: v => formatNumber(v),
            font: { size: 20, weight: "bold" }
          }
        }
      }
    });

    chartRef.current = chart;
    window[id] = chart;

    return () => {
      chart.destroy();
      delete window[id];
    };

  }, [rows, valueKey, id]);

  return (
    <div style={{
      width: "100%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    }}>
      <canvas ref={canvasRef} />
    </div>
  );
}
